<div style="font-family: 'Roboto'; min-height: 100vh; width: 100vw;">
  <div id="homepageSwiperWrapper" style="position: relative; overflow: hidden;"
    class="homepage-header-bg commerical-banner-background-color shippn-main-banner-swiper-wrapper">
    <div>
      <swiper-container class="col-md-12 shippn-swiper-slider-wrapper-swiper shippn-main-banner-swiper-swiper-container"
        loop="true" pagination="true" pagination-clickable="true" autoplay-delay="10000"
        autoplay-disable-on-interaction="false" id="shippn-main-banner-swiper" keyboard="true">
        <swiper-slide class="main-banner-slide-first more-than-35-countries">
          <div class="container padding-0">
            <div class="main-banner-text">
              <h2>
                <span class="size-standard-h1 color-banner-orange">Unlock Borderless Shopping</span>
                <span class="size-small-h1 color-banner-black">From More Than</span>
                <span class="size-big-h1 color-banner-black"><span translate="no">{{hostCountriesCount}}
                  </span>Countries</span>
              </h2>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="main-banner-slide-second shop-internationally-bg">
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
  <div id="home-banner-animated-banner">
    <home-banner-animated-html></home-banner-animated-html>
  </div>
  <div class="container shippn-homepage-container">
    <div class="row" *ngIf="isWelcomePage === false">
      <div class="col-12 d-md-none d-lg-none d-xs-block d-sm-block d-block">
        <div
          style="background-color: white; border-radius: 16px; margin: 15px auto; box-shadow: rgba(0,0,0,0.1) 0px 10px 50px; text-align: center;">
          <div class="row">
            <div style="padding-right: 0;" class="col-6">
              <div [ngClass]="{'homepage-tab-active':BFMTab}"
                style="border-top-left-radius:16px;border-bottom: 1px solid #3d85b0;min-height: 80px;">
                <div style="text-align: left;">
                  <span
                    style="margin-left: 15px;background-color: red;color: white;padding: 2px 8px;border-radius: 6px;font-size: 10px;">New</span>
                </div>
                <h4 (click)="BFMTab=true;shopFromTab=false;"
                  style="margin:0;display: grid;align-items: center;height: 42px;cursor: pointer;font-size: 15px;padding-bottom: 10px;">
                  Buy For Me <br> Service</h4>
              </div>
            </div>
            <div style="padding-left: 0;" class="col-6">
              <div [ngClass]="{'homepage-tab-active':shopFromTab}"
                style="border-top-right-radius:16px;border-bottom: 1px solid #3d85b0;min-height: 80px;">
                <h4 (click)="BFMTab=false;shopFromTab=true;"
                  style="margin:0;height:78px;display:grid;align-items:center;cursor: pointer;font-size: 15px;">Shop
                  From</h4>
              </div>
            </div>
          </div>
          <div *ngIf="BFMTab" class="row">
            <form ngNativeValidate [formGroup]="bfmMailForm" style="width: 100%;">
              <div class="col-12">
                <div
                  style="background-color: #fff; border-radius: 16px; margin: 0 auto; box-shadow: none; text-align: left; padding: 24px 12px 18px 12px;">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <h3 style="margin: 0; font-size: 1.1rem; font-weight: 700;">Buy For Me Service</h3>
                    <span
                      style="background: #fff4e6; color: #ff7700; font-size: 12px; border-radius: 8px; padding: 2px 10px; font-weight: 600;">We
                      shop for you</span>
                  </div>
                  <p style="margin: 8px 0 14px 0; color: #444; font-size: 14px;">We'll complete the purchase on your
                    behalf using a secure checkout process with full buyer protection.</p>
                  <label for="bfmMailInputMobile"
                    style="font-size: 13px; font-weight: 600; margin-bottom: 6px; display: block;">Paste the product
                    link here</label>
                  <input id="bfmMailInputMobile" placeholder="https://www.example.com/product-link"
                    formControlName="bfmMail"
                    [ngClass]="{'shippn-border-red':bfmMailForm.get('bfmMail').touched && bfmMailForm.get('bfmMail').invalid}"
                    type="text" class="form-control shippn-input" style="margin-bottom: 8px; font-size: 14px;">
                  <div style="color: #888; font-size: 12px; margin-bottom: 10px;">Supported: Amazon, eBay, Target, Best
                    Buy, and 1000+ stores</div>
                  <div style="display: flex; flex-wrap: wrap; gap: 8px 0; margin-bottom: 8px;">
                    <div
                      style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                      <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Save up to 75% on shipping
                    </div>
                    <div
                      style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                      <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Package consolidation
                    </div>
                    <div
                      style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                      <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Fast delivery
                    </div>
                    <div
                      style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                      <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure handling
                    </div>
                    <div
                      style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                      <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Buyer protection guarantee
                    </div>
                    <div
                      style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                      <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure payment processing
                    </div>
                  </div>
                  <div
                    style="background: #f3f7ff; color: #2563eb; border-radius: 8px; padding: 7px 10px; font-size: 13px; margin-bottom: 10px; display: flex; align-items: center; gap: 7px;">
                    <i class="fas fa-truck"></i> Estimated delivery: 1-5 business days
                  </div>
                  <div style="margin-bottom: 10px;">
                    <span (click)="goBFM()" class="btn shippn-from-to-area-go-btn shippn-btn-min120 croBFMBtn"
                      style="width: 100%; font-size: 16px; font-weight: 700; background: #ff7700; color: #fff; border-radius: 8px; padding: 10px 0;">Get
                      Quote & Buy Now</span>
                  </div>
                  <div
                    style="background: #e6f7ea; color: #1a7f37; border-radius: 8px; padding: 7px 10px; font-size: 13px; margin-bottom: 10px; display: flex; align-items: center; gap: 7px;">
                    <i class="fas fa-check-circle"></i> Service fee: Only 8% + $5 or $10 depending on product's value
                  </div>
                  <div
                    style="display: flex; align-items: center; gap: 12px; font-size: 12px; color: #888; margin-top: 6px; justify-content: center;">
                    <span><i class="fas fa-lock"></i> SSL Secured</span>
                    <span><i class="fab fa-cc-paypal"></i> PayPal Protected</span>
                    <span><i class="fas fa-headset"></i> 24/7 Support</span>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="shopFromTab" class="row">
            <div class="col-12">
              <div
                style="background-color: #fff; border-radius: 16px; margin: 0 auto; box-shadow: none; text-align: left; padding: 24px 12px 18px 12px;">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <h3 style="margin: 0; font-size: 1.1rem; font-weight: 700;">Shop from Global Stores</h3>
                  <span
                    style="background: #e6f7ea; color: #1a7f37; font-size: 12px; border-radius: 8px; padding: 2px 10px; font-weight: 600;">Shop
                    yourself</span>
                </div>
                <p style="margin: 8px 0 14px 0; color: #444; font-size: 14px;">Select a host to receive a local shipping
                  address and use it at checkout when shopping online</p>
                <label for="countryFromSelectMobile"
                  style="font-size: 13px; font-weight: 600; margin-bottom: 6px; display: block;">Choose your shipping
                  destination</label>
                <div style="position: relative; margin-bottom: 8px;">
                  <i class="fas fa-chevron-down"
                    style="position: absolute; right: 12px; top: 14px; color: #222; font-size: 12px; pointer-events: none;"></i>
                  <select (change)="test(countryFrom)" id="countryFromSelectMobile" name="countryFromSelectMobile"
                    [(ngModel)]="countryFrom" class="form-control-sm"
                    style="appearance: none; border-radius: 5px; font-size: 14px; height: 40px; cursor: pointer; width: 100%;">
                    <option *ngFor="let countriesWithHost of hostCountries; trackBy:trackByIndex"
                      value="{{countriesWithHost.code}}">
                      <span
                        *ngIf="countriesWithHost.code != 'TR' && countriesWithHost.name != 'Turkey'">{{countriesWithHost.name}}</span>
                      <span *ngIf="countriesWithHost.code == 'TR' || countriesWithHost.name == 'Turkey'"
                        translate="no">Türkiye</span>
                    </option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div style="color: #888; font-size: 12px; margin-bottom: 10px;">Available in 40+ countries worldwide
                </div>
                <div style="display: flex; flex-wrap: wrap; gap: 8px 0; margin-bottom: 8px;">
                  <div
                    style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                    <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Save up to 75% on shipping
                  </div>
                  <div
                    style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                    <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Package consolidation
                  </div>
                  <div
                    style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                    <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Fast delivery
                  </div>
                  <div
                    style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                    <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure handling
                  </div>
                  <div
                    style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                    <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Buyer protection guarantee
                  </div>
                  <div
                    style="width: 50%; display: flex; align-items: center; gap: 6px; font-size: 13px; margin-bottom: 2px;">
                    <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure payment processing
                  </div>
                </div>
                <div
                  style="background: #f3f7ff; color: #2563eb; border-radius: 8px; padding: 7px 10px; font-size: 13px; margin-bottom: 10px; display: flex; align-items: center; gap: 7px;">
                  <i class="fas fa-truck"></i> Estimated delivery: 1-5 business days
                </div>
                <div style="margin-bottom: 10px;">
                  <span (click)="goLocation(countryFrom)" analytics-on="click" analytics-event="hostlisting"
                    class="btn shippn-from-to-area-go-btn shippn-btn-min120 croShopFromBtn" id="goBtn"
                    style="width: 100%; font-size: 16px; font-weight: 700; background: #ff7700; color: #fff; border-radius: 8px; padding: 10px 0;">Get
                    My Address Now</span>
                </div>
                <div
                  style="background: #e6f7ea; color: #1a7f37; border-radius: 8px; padding: 7px 10px; font-size: 13px; margin-bottom: 10px; display: flex; align-items: center; gap: 7px;">
                  <i class="fas fa-check-circle"></i> Free address setup • No monthly fees
                </div>
                <div style="font-size: 12px; color: #888; margin-top: 8px; text-align: center;">Shop from top brands and
                  thousands more:</div>
                <div style="display: flex; flex-wrap: wrap; gap: 5px; margin-top: 5px; justify-content: center;">
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Shein</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Walmart</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Amazon</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Macy's</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Carter's</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Neiman
                    Marcus</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Target</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Bath
                    & Body Works</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">American
                    Eagle</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Crate
                    & Barrel</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">Newegg</span>
                  <span
                    style="background: #f3f3f3; border-radius: 6px; padding: 2px 8px; font-size: 12px; color: #444;">and
                    many more</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 d-none d-sm-none d-xs-none d-md-block d-lg-block"
        [ngClass]="{'shippn-not-active-card':!desktopShopFromTab}" style="padding: 0 10px;">
        <div
          style="background-color: #fff; border-radius: 16px; margin: 15px auto; box-shadow: rgba(0,0,0,0.1) 0px 10px 50px; text-align: left; min-height: 480px; padding: 32px 28px 24px 28px; display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
          <div>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <h3 style="margin: 0; font-size: 1.5rem; font-weight: 700;">Shop from Global Stores</h3>
              <span
                style="background: #e6f7ea; color: #1a7f37; font-size: 13px; border-radius: 8px; padding: 2px 12px; font-weight: 600;">Shop
                yourself</span>
            </div>
            <p style="margin: 8px 0 18px 0; color: #444; font-size: 15px;">Select a host to receive a local shipping
              address and use it at checkout when shopping online</p>
            <label for="countryFromSelectDesktop"
              style="font-size: 14px; font-weight: 600; margin-bottom: 6px; display: block;">Choose your shipping
              destination</label>
            <div style="position: relative; margin-bottom: 8px;">
              <i class="fas fa-chevron-down"
                style="position: absolute; right: 16px; top: 14px; color: #222; font-size: 13px; pointer-events: none;"></i>
              <select (change)="test(countryFrom)" id="countryFromSelectDesktop" name="countryFromSelectDesktop"
                [(ngModel)]="countryFrom" class="form-control"
                style="appearance: none; border-radius: 5px; padding: 11px 14px; font-size: 15px; height: 42px; cursor: pointer;">
                <option *ngFor="let countriesWithHost of hostCountries;trackBy:trackByIndex"
                  value="{{countriesWithHost.code}}">
                  <span
                    *ngIf="countriesWithHost.code != 'TR' && countriesWithHost.name != 'Turkey'">{{countriesWithHost.name}}</span>
                  <span *ngIf="countriesWithHost.code == 'TR' || countriesWithHost.name == 'Turkey'"
                    translate="no">Türkiye</span>
                </option>
                <option value="other">Other</option>
              </select>
            </div>
            <div style="color: #888; font-size: 13px; margin-bottom: 12px;">Available in 40+ countries worldwide</div>
            <div style="display: flex; flex-wrap: wrap; gap: 12px 0; margin-bottom: 10px;">
              <div
                style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Save up to 75% on shipping
              </div>
              <div
                style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Package consolidation
              </div>
              <div
                style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Fast delivery
              </div>
              <div
                style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure handling
              </div>
              <div
                style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Buyer protection guarantee
              </div>
              <div
                style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure payment processing
              </div>
            </div>
            <div
              style="background: #f3f7ff; color: #2563eb; border-radius: 8px; padding: 8px 12px; font-size: 15px; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
              <i class="fas fa-truck"></i> Estimated delivery: 1-5 business days
            </div>
            <div style="margin-bottom: 12px;">
              <span (click)="goLocation(countryFrom)" analytics-on="click" analytics-event="hostlisting"
                class="btn shippn-from-to-area-go-btn shippn-btn-min120 croShopFromBtn" id="btnGO"
                style="width: 100%; font-size: 18px; font-weight: 700; background: #ff7700; color: #fff; border-radius: 8px; padding: 12px 0;">Get
                My Address Now</span>
            </div>
            <div
              style="background: #e6f7ea; color: #1a7f37; border-radius: 8px; padding: 8px 12px; font-size: 15px; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
              <i class="fas fa-check-circle"></i> Free address setup • No monthly fees
            </div>
            <div style="font-size: 13px; color: #888; margin-top: 10px; text-align: center;">Shop from top brands and
              thousands more:</div>
            <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px; justify-content: center;">
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Shein</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Walmart</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Amazon</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Macy's</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Carter's</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Neiman
                Marcus</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Target</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Bath &
                Body Works</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">American
                Eagle</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Crate
                & Barrel</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">Newegg</span>
              <span
                style="background: #f3f3f3; border-radius: 6px; padding: 2px 10px; font-size: 13px; color: #444;">and
                many more</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 d-none d-xs-none d-sm-none d-md-block d-lg-block"
        [ngClass]="{'shippn-not-active-card':!desktopBFMTab}" style="padding: 0 10px;">
        <form ngNativeValidate [formGroup]="bfmMailForm" style="height: 100%;">
          <div
            style="background-color: #fff; border-radius: 16px; margin: 15px auto; box-shadow: rgba(0,0,0,0.1) 0px 10px 50px; text-align: left; min-height: 480px; padding: 32px 28px 24px 28px; display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
            <div>
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <h3 style="margin: 0; font-size: 1.5rem; font-weight: 700;">Buy For Me Service</h3>
                <span
                  style="background: #fff4e6; color: #ff7700; font-size: 13px; border-radius: 8px; padding: 2px 12px; font-weight: 600;">We
                  shop for you</span>
              </div>
              <p style="margin: 8px 0 18px 0; color: #444; font-size: 15px;">We'll complete the purchase on your behalf
                using a secure checkout process with full buyer protection.</p>
              <label for="bfmMailInputDesktop"
                style="font-size: 14px; font-weight: 600; margin-bottom: 6px; display: block;">Paste the product link
                here</label>
              <input id="bfmMailInputDesktop" placeholder="https://www.example.com/product-link"
                formControlName="bfmMail"
                [ngClass]="{'shippn-border-red':bfmMailForm.get('bfmMail').touched && bfmMailForm.get('bfmMail').invalid}"
                type="text" class="form-control shippn-input" style="margin-bottom: 8px; font-size: 15px;">
              <div style="color: #888; font-size: 13px; margin-bottom: 12px;">Supported: Amazon, eBay, Target, Best Buy,
                and 1000+ stores</div>
              <div style="display: flex; flex-wrap: wrap; gap: 12px 0; margin-bottom: 10px;">
                <div
                  style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                  <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Save up to 75% on shipping
                </div>
                <div
                  style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                  <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Package consolidation
                </div>
                <div
                  style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                  <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Fast delivery
                </div>
                <div
                  style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                  <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure handling
                </div>
                <div
                  style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                  <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Buyer protection guarantee
                </div>
                <div
                  style="width: 50%; display: flex; align-items: center; gap: 7px; font-size: 14px; margin-bottom: 2px;">
                  <i class="fas fa-check-circle" style="color: #1a7f37;"></i> Secure payment processing
                </div>
              </div>
              <div
                style="background: #f3f7ff; color: #2563eb; border-radius: 8px; padding: 8px 12px; font-size: 15px; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
                <i class="fas fa-truck"></i> Estimated delivery: 1-5 business days
              </div>
              <div style="margin-bottom: 12px;">
                <span (click)="goBFM()" class="btn shippn-from-to-area-go-btn shippn-btn-min120 croBFMBtn"
                  style="width: 100%; font-size: 18px; font-weight: 700; background: #ff7700; color: #fff; border-radius: 8px; padding: 12px 0;">Get
                  Quote & Buy Now</span>
              </div>
              <div
                style="background: #e6f7ea; color: #1a7f37; border-radius: 8px; padding: 8px 12px; font-size: 15px; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
                <i class="fas fa-check-circle"></i> Service fee: Only 8% + $5 or $10 depending on product's value
              </div>
              <div
                style="display: flex; align-items: center; gap: 18px; font-size: 13px; color: #888; margin-top: 8px; justify-content: center;">
                <span><i class="fas fa-lock"></i> SSL Secured</span>
                <span><i class="fab fa-cc-paypal"></i> PayPal Protected</span>
                <span><i class="fas fa-headset"></i> 24/7 Support</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row" *ngIf="isWelcomePage === true">
      <div class="col-12">
        <div class="welcome-start-shopping-wrapper">
          <div class="welcome-start-shopping">
            <h4 class="welcome-start-shopping-title">Start Your Global Shopping</h4>
            <p class="welcome-start-shopping-text">Shop From Any Store Worldwide With Shippn!</p>
            <div class="welcome-start-shopping-btn-area">
              <a href="/shop-now?welcome=shippn" class="btn shippn-from-to-area-go-btn welcome-start-shopping-btn">Shop
                Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container shippn-homepage-container">
    <div class="row">
      <div class="col-12 mt-top40">
        <app-shippnpilot-widget [shippnpilotWidgetType]="'both'"></app-shippnpilot-widget>
      </div>
    </div>
  </div>

  <div class="container-fluid smart-consolidation-bg">
    <div class="container shippn-homepage-container m-pad-0">
      <div class="row">
        <div class="col-12">
          <div class="smart-consolidation-card">
            <h2 class="smart-consolidation-title header-underline">Smart Package Consolidation</h2>
            <div class="smart-consolidation-desc">
              Maximize savings and minimize hassle by combining multiple purchases into one shipment
            </div>
            <div class="row smart-consolidation-features">
              <div class="col-12 col-md-3 mb-4 mb-md-0 d-flex flex-column align-items-center">
                <div class="smart-consolidation-feature-icon smart-consolidation-feature-icon-blue">
                  <i class="fas fa-cube"></i>
                </div>
                <div class="smart-consolidation-feature-title">Multiple Purchases</div>
                <div class="smart-consolidation-feature-desc">Buy from different stores using our service</div>
              </div>
              <div class="col-12 col-md-3 mb-4 mb-md-0 d-flex flex-column align-items-center">
                <div class="smart-consolidation-feature-icon smart-consolidation-feature-icon-purple">
                  <i class="fas fa-warehouse"></i>
                </div>
                <div class="smart-consolidation-feature-title">Warehouse Storage</div>
                <div class="smart-consolidation-feature-desc">Items stored safely for up to 30 days</div>
              </div>
              <div class="col-12 col-md-3 mb-4 mb-md-0 d-flex flex-column align-items-center">
                <div class="smart-consolidation-feature-icon smart-consolidation-feature-icon-green">
                  <i class="fas fa-check-circle"></i>
                </div>
                <div class="smart-consolidation-feature-title">Smart Consolidation</div>
                <div class="smart-consolidation-feature-desc">Easily manage and consolidate your packages</div>
              </div>
              <div class="col-12 col-md-3 d-flex flex-column align-items-center">
                <div class="smart-consolidation-feature-icon smart-consolidation-feature-icon-orange">
                  <i class="fas fa-globe"></i>
                </div>
                <div class="smart-consolidation-feature-title">Single Shipment</div>
                <div class="smart-consolidation-feature-desc">One package, maximum savings</div>
              </div>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center">
              <div class="smart-consolidation-saving-box">
                <div class="smart-consolidation-price-old">$60</div>
                <div class="smart-consolidation-price-old-label">Individual shipping</div>
                <i class="fas fa-arrow-right smart-consolidation-arrow"></i>
                <div class="smart-consolidation-price-new">$25</div>
                <div class="smart-consolidation-price-new-label">Consolidated shipping</div>
                <span class="smart-consolidation-saving-badge">Save $35</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="shippn-homepage-container container" style="margin-top: 20px;">
    <div class="row">
      <div class="col-12">
        <h4 class="top-global-stores-section-title header-underline">Shop Global Stores & Ship Internationally</h4>
        <p class="top-global-stores-section-subtext">
          Choose your favorite store below or explore our <a [routerLink]="['/','stores']">how to shop global stores
            page</a> to see how Shippn can assist you in shipping from countries like the USA and Europe. With Shippn,
          you have the opportunity to shop and ship from 39 different countries and territories, ensuring satisfied
          customers across the globe, including regions like the USA, United Kingdom, Germany, Australia, Italy,
          Netherlands, Japan, and many more!
        </p>
        <div class="top-global-stores-wrapper">
          <div class="top-global-stores-store" *ngFor="let store of topGlobalStores">
            <div class="top-global-stores-store-image" [routerLink]="['/','stores', store.urlPart]">
              <img fetchpriority="low" loading="lazy" decoding="auto" src="{{store.image}}" alt="{{store.name}} logo">
            </div>
          </div>
        </div>
        <div class="top-global-stores-footer">
          <a [routerLink]="['/','stores']" class="btn btn-success btn-blue-inset">Show All</a>
        </div>
      </div>
    </div>
  </div>
  <div class="shippn-homepage-container container" style="margin-top: 20px;">
    <div class="row">
      <div class="col-md-12">
        <h4 class="header-underline top-rated-routes-section-title">
          TOP RATED ROUTES
        </h4>
      </div>
    </div>
    <div class="row shippn-swiper-slider-wrapper">
      <swiper-container class="col-md-12 shippn-swiper-slider-wrapper-swiper" loop="true"
        id="shippn-rated-routes-swiper">
        <swiper-slide *ngFor="let route of topRatedRouteList; let i = index; trackBy:trackByIndex;">
          <div class="top-rated-route">
            <div class="route-from">
              <img fetchpriority="low" width="20" height="20" loading="lazy" decoding="auto"
                class="completed-purchase-countries-flag" src="{{route.routeFromFlag}}"
                alt="{{route.routeFromName}} flag">
              <span class="route-country-label">From </span>
              <span>{{route.routeFromName}} </span>
            </div>
            <div class="route-to">
              <img fetchpriority="low" width="20" height="20" loading="lazy" decoding="auto"
                class="completed-purchase-countries-flag" src="{{route.routeToFlag}}" alt="{{route.routeToName}} flag">
              <span class="route-country-label">To </span>
              <span>{{route.routeToName}} </span>
            </div>
            <div class="route-starting-price">
              <span>{{route.routePrice}}<span style="font-size: 15px;">/per kg</span></span>
              <span class="route-starts-from">Based on 10kg parcel</span>
            </div>
            <div class="route-call-to-action">
              <button class="btn shippn-from-to-area-go-btn route-get-address" aria-labelledby="Get Your Address"
                [routerLink]="['/','shop-from', route.routeFrom]" [queryParams]="{source: 'home_trr'}">Get
                your address</button>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
      <button id="topRoute-prev" aria-label="Top Routes Slider Prev"
        class="swiper-navigation-custom-btn swiper-custom-btn-prev"><i class="fas fa-chevron-left"></i></button>
      <button id="topRoute-next" class="swiper-navigation-custom-btn swiper-custom-btn-next"
        aria-label="Top Routes Slider Next"><i class="fas fa-chevron-right"></i></button>
    </div>
  </div>
  <div class="container-fluid" style="background-color: #222; padding-bottom: 50px;">
    <div class="shippn-homepage-container container m-pad-0" style="margin-top: 20px;">
      <div class="row">
        <div class="col-md-12">
          <h4 class="header-underline-white"
            style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 40px;margin-top: 50px; color:#fff">
            Happy Deliveries Make Happy Customers!
          </h4>
          <div class="shippn-reviews-swiper-header">
            <div class="shippn-reviews-swiper-header-rating">
              <div class="shippn-reviews-swiper-header-rating-start-rating">
                <img src="../assets/img/shippn-reviews/star.png" alt="Shippn Reviews Rating Star" style="height: 22px;">
                <span style="color:#f36c37;font-weight: 600;font-size: 18px;">4.6/5</span>
              </div>
              <span style="color:#fff; font-size: 18px;font-weight: 600;">Rating</span>
            </div>
            <div class="shippn-reviews-swiper-header-shippnpilot">
              <!-- <img src="../assets/img/shippn-reviews/shippnpilot_logo.svg" alt="Shippn Reviews Logo Star"
                style="height: 40px;"> -->
            </div>
            <div class="shippn-reviews-swiper-header-reviews-count">
              <div class="shippn-reviews-swiper-header-reviews-count-icon-count">
                <img src="../assets/img/shippn-reviews/chat.png" alt="Shippn Reviews Rating Star" style="height: 22px;">
                <span style="color:#f36c37;font-weight: 600;font-size: 18px;">619</span>
              </div>
              <span style="color:#fff;font-size: 18px;font-weight: 600;">Reviews</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row shippn-swiper-slider-wrapper">
        <swiper-container class="col-md-12 shippn-swiper-slider-wrapper-swiper" loop="true"
          id="shippnpilotReviewsSwiper" slides-per-view="auto">
          <swiper-slide *ngFor="let tpReview of shippnpilotReviews; let i = index; trackBy:trackByIndex;"
            class="tp-swiper-slide">
            <div class="shippn-reviews-review">
              <div style="display:flex; flex-direction: column; gap: 10px;">
                <div class="shippn-reviews-review-header">
                  <div class="shippn-reviews-review-rating">
                    <div class="shippn-reviews-review-rating-star">
                      <div *ngFor="let index of arrayMaker(tpReview?.review_rating)">
                        <img src="../assets/img/shippn-reviews/star.png" alt="Shippn Reviews Rating Star"
                          style="height: 14px;">
                      </div>
                    </div>
                  </div>
                  <div class="shippn-reviews-review-title">
                    <h5>{{tpReview.review_title}}</h5>
                  </div>
                </div>
                <div class="shippn-reviews-review-content">
                  <p>
                    {{tpReview.review_content}}
                  </p>
                </div>
              </div>
              <div class="shippn-reviews-review-footer">
                <div class="shippn-reviews-review-country-flag">
                  <img src="{{tpReview.review_country_flag}}" alt="" height="20px">
                </div>
                <div class="shippn-reviews-review-user">
                  <h6>{{tpReview.review_user}}</h6>
                  <span>{{tpReview.review_country}}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
        <button id="shippnpilotReviewsSwiper-prev" aria-label="Top Routes Slider Prev"
          class="swiper-navigation-custom-btn swiper-custom-btn-prev"><i class="fas fa-chevron-left"></i></button>
        <button id="shippnpilotReviewsSwiper-next" class="swiper-navigation-custom-btn swiper-custom-btn-next"
          aria-label="Top Routes Slider Next"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
  <div class="shippn-homepage-container container">
    <div class="row">
      <div class="col-md-12">
        <h4 class="header-underline"
          style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 27px;margin-top: 50px;">HOW
          SHIPPN WORKS?</h4>
      </div>
    </div>
    <div style="margin-top: 35px;" class="row">
      <div style="text-align: center;" class="col-md-4">
        <img fetchpriority="low" style="width: 40px;" async src="../assets/img/address.webp" alt="Address Icon"
          loading="lazy" decoding="auto" width="40px" height="40px">
        <h4 style="text-align: center;font-size: 18px;font-weight: bold;margin-bottom: 12px;margin-top: 10px;">GET AN
          ADDRESS</h4>
        <p style="font-size: 14px;line-height: 20px;">Choose one of Shippn hosts in the country you want to shop from.
          No sign-up or set up fees.</p>
      </div>
      <div style="text-align: center;" class="col-md-4">
        <img fetchpriority="low" style="width: 40px;" async src="../assets/img/smartphone.webp" alt="Smartphone Icon"
          loading="lazy" decoding="auto" width="40px" height="40px">
        <h4 style="text-align: center;font-size: 18px;font-weight: bold;margin-bottom: 12px;margin-top: 10px;">SHOP FROM
          ANY STORE</h4>
        <p style="font-size: 14px;line-height: 20px;">Use your host's address as your
          delivery address at checkout.</p>
      </div>
      <div style="text-align: center;" class="col-md-4">
        <img fetchpriority="low" style="width: 40px;" async src="../assets/img/package.webp" alt="Package, box icon"
          loading="lazy" decoding="auto" width="40px" height="36px">
        <h4 style="text-align: center;font-size: 18px;font-weight: bold;margin-bottom: 12px;margin-top: 10px;">RECEIVE
          YOUR ITEMS</h4>
        <p style="font-size: 14px;line-height: 20px;">Receive your packages with trusted
          logistics partners, DHL, TNT, UPS,
          and FedEx. Save up to 70% on
          shipping</p>
      </div>
      <div style="text-align: center;margin-top: 20px;" class="col-md-12">
        <span (click)="goLocation('howitworks-for-shoppers')"
          style="background-color: white;border: 1px solid #3d85b0;color: #3d85b0;font-size: 14px;cursor: pointer;"
          class="btn btn-primary">Learn More</span>
      </div>
    </div>
    <div style="margin-top: 20px;" class="row">
      <div class="col-12">
        <h4 class="header-underline"
          style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 27px;margin-top: 30px;">Shippn: Top
          Choice for International Buyers!</h4>
        <div class="for-desktop-and-tablet">
          <div class="influencer-videos-wrapper">
            <div class="influencer-video" *ngFor="let video of influencerVideos" (click)="openYTVideoDialog(video)">
              <img src="{{video.thumbnail}}" alt="{{video.title}}">
              <div class="influencer-video-play-icon">
                <i class="fab fa-youtube"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="for-mobile">
          <div class="influencer-videos-wrapper">
            <swiper-container class="col-md-12 shippn-swiper-slider-wrapper-swiper" loop="true"
              id="influencerVideosSwiper">
              <swiper-slide *ngFor="let video of influencerVideos; let i = index; trackBy:trackByIndex;">
                <div class="influencer-video" (click)="openYTVideoDialog(video)">
                  <img src="{{video.thumbnail}}" alt="{{video.title}}">
                  <div class="influencer-video-play-icon">
                    <i class="fab fa-youtube"></i>
                  </div>
                </div>
              </swiper-slide>
            </swiper-container>
            <button id="influencerVideosSwiper-prev" aria-label="influencerVideosSwiper Slider Prev"
              class="swiper-navigation-custom-btn swiper-custom-btn-prev" style="left: 10px;"><i
                class="fas fa-chevron-left"></i></button>
            <button id="influencerVideosSwiper-next" class="swiper-navigation-custom-btn swiper-custom-btn-next"
              aria-label="influencerVideosSwiper Slider Next" style="right: 10px;"><i
                class="fas fa-chevron-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="background-color: #222222;margin-top: 50px;" class="container-fluid">
    <div class="row">
      <div style="text-align: center;" class="col-md-12">
        <h4 class="header-underline-white"
          style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 27px;color: white;margin-top: 27px;">
          START SHOPPING NOW</h4>
        <p style="color: white;margin-bottom: 27px;font-size: 14px;">Shippn lets you shop from any store in the world!
        </p>
      </div>
    </div>
  </div>
  <div style="background-color: #7c7c7c;" class="container-fluid">
    <div style="border-bottom: 1px solid #ffffff4d;" class="row">
      <div
        style="padding-left: 0;padding-right: 0;border: 1px solid #ffffff4d;display: inline-grid;align-items: center;min-height: 200px;"
        class="col-4 col-md-2">
        <div style="text-align: center;">
          <img fetchpriority="low" style="width: 40%;" loading="lazy" decoding="auto" src="../assets/img/brand-gap.webp"
            alt="GAP Logo">
        </div>
      </div>
      <div
        style="padding-left: 0;padding-right: 0;border: 1px solid #ffffff4d;display: inline-grid;align-items: center;min-height: 200px;"
        class="col-4 col-md-2">
        <div style="text-align: center;">
          <img fetchpriority="low" style="width: 40%;" loading="lazy" decoding="auto"
            src="../assets/img/brand-guess.webp" alt="Guess Logo">
        </div>
      </div>
      <div
        style="padding-left: 0;padding-right: 0;border: 1px solid #ffffff4d;display: inline-grid;align-items: center;min-height: 200px;"
        class="col-4 col-md-2">
        <div style="text-align: center;">
          <img fetchpriority="low" style="width: 55%;" loading="lazy" decoding="auto"
            src="../assets/img/brand-skechers.webp" alt="Skechers Logo">
        </div>
      </div>
      <div
        style="padding-left: 0;padding-right: 0;border: 1px solid #ffffff4d;display: inline-grid;align-items: center;min-height: 200px;"
        class="col-4 col-md-2">
        <div style="text-align: center;">
          <img fetchpriority="low" style="width: 55%;" loading="lazy" decoding="auto"
            src="../assets/img/brand-amazon.webp" alt="Amazon Logo">
        </div>
      </div>
      <div
        style="padding-left: 0;padding-right: 0;border: 1px solid #ffffff4d;display: inline-grid;align-items: center;min-height: 200px;"
        class="col-4 col-md-2">
        <div style="text-align: center;">
          <img fetchpriority="low" style="width: 40%;" loading="lazy" decoding="auto"
            src="../assets/img/brand-ebay.webp" alt="Jones New York Logo">
        </div>
      </div>
      <div
        style="padding-left: 0;padding-right: 0;border: 1px solid #ffffff4d;display: inline-grid;align-items: center;min-height: 200px;"
        class="col-4 col-md-2">
        <div style="text-align: center;">
          <img fetchpriority="low" style="width: 40%;" loading="lazy" decoding="auto"
            src="../assets/img/brand-timberland.webp" alt="Timberland Logo">
        </div>
      </div>
    </div>
  </div>
  <div style="background-size: cover; background-repeat: no-repeat;" LazyLoad="../assets/img/country-background.webp">
    <div class="shippn-homepage-container container">
      <div class="row">
        <div style="text-align: center;" class="col-md-12">
          <h4 class="header-underline-white"
            style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 27px;color: white;margin-top: 55px;">
            SHOP FROM ANYWHERE IN THE WORLD</h4>
          <p style="color: white;margin-bottom: 27px;font-size: 14px;">Let our host forward your package to your home
            address</p>
          <div style="margin-bottom: 60px;" class="carousel slide country-slide-padding" id="slider"
            data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div style="height: 100%;" class="row">
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('uk')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">UK</h2>
                    <a href="/shop-from/uk" style="width:100%">
                      <img fetchpriority="low" loading="lazy" decoding="auto" width="100%" height="100%" srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-london-bg@576.webp 2x,
                            https://d1we2hgzmci25y.cloudfront.net/assets/img/region-london-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-london-bg.webp"
                        alt="United Kingdom London Westminster Bridge and Big Ben"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('us')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">U.S.A.</h2>
                    <a href="/shop-from/us" style="width:100%">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newyork-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newyork-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newyork-bg.webp"
                        alt="Shop from United States New York Night"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('ca')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">CANADA</h2>
                    <a href="/shop-from/ca" style="width:100%">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-toronto-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-toronto-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-toronto-bg.webp"
                        alt="Shop from Canada Toronto"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('tr')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">TÜRKİYE</h2>
                    <a href="/shop-from/tr" style="width:100%">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-istanbul-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-istanbul-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-istanbul-bg.webp"
                        alt="Shop from Turkey Istanbul "
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('au')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">AUSTRALIA</h2>
                    <a href="/shop-from/au" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-australia-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-australia-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-australia-bg.webp"
                        alt="Shop from Austraila Sydney"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('de')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">GERMANY</h2>
                    <a href="/shop-from/de" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-germany-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-germany-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-germany-bg.webp"
                        alt="Shop from Germany"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="row">
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('cn')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">CHINA</h2>
                    <a href="/shop-from/cn" style="width:100%">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-china-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-china-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-china-bg.webp"
                        alt="Shop from China"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('fr')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">FRANCE</h2>
                    <a href="/shop-from/fr" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-france-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-france-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-france-bg.webp"
                        alt="Shop form France, Paris Eiffel Tower"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('ae')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">UAE</h2>
                    <a href="/shop-from/ae" style="width:100%">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-unitedarab-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-unitedarab-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-unitedarab-bg.webp"
                        alt="Shop from United Arab Emirates"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('in')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">INDIA</h2>
                    <a href="/shop-from/in" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-india-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-india-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-india-bg.webp"
                        alt="Shop from India"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('it')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">ITALY</h2>
                    <a href="/shop-from/it" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-italy-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-italy-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-italy-bg.webp"
                        alt="Shop from Italy Venice"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('jp')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">JAPAN</h2>
                    <a href="/shop-from/jp" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-tokyo-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-tokyo-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-tokyo-bg.webp"
                        alt="Shop from Japan Tokyo Tokio"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="row">
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('nl')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">NETHERLANDS</h2>
                    <a href="/shop-from/nl" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-holland-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-holland-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-holland-bg.webp"
                        alt="Shop from Netherlands Holland Amsterdam"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('nz')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">NEW ZEALAND</h2>
                    <a href="/shop-from/nz" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newzealand-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newzealand-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-newzealand-bg.webp"
                        alt="Shop from New Zealand"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('ph')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">PHILIPPINES</h2>
                    <a href="/shop-from/ph" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-philippines-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-philippines-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-philippines-bg.webp"
                        alt="Shop from PHILIPPINES"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('sg')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">SINGAPORE</h2>
                    <a href="/shop-from/sg" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-singapore-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-singapore-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-singapore-bg.webp"
                        alt="Shop from Singapore"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('kr')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">SOUTH KOREA</h2>
                    <a href="/shop-from/kr" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-southkorea-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-southkorea-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-southkorea-bg.webp"
                        alt="Shop from South Korea"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                  <div
                    style="display: flex;align-items: center;padding-top: 20px;text-align:center;justify-content:center;"
                    class="col-6 col-md-4">
                    <h2 (click)="goLocation('es')" class='top-countries-country-name'
                      style="color: white;position: absolute;margin:0;cursor: pointer;z-index: 500">SPAIN</h2>
                    <a href="/shop-from/es" style="width: 100%;">
                      <img fetchpriority="low" loading="lazy" decoding="auto"
                        srcset="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-spain-bg@576.webp 2x, https://d1we2hgzmci25y.cloudfront.net/assets/img/region-spain-bg.webp 1x"
                        src="https://d1we2hgzmci25y.cloudfront.net/assets/img/region-spain-bg.webp"
                        alt="Shop from Spain"
                        style="width:100%;border-radius:5px;object-fit: cover;filter: brightness(50%)">
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <a class="carousel-control-prev" href="#slider" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#slider" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="shippn-homepage-container container">
    <div class="row">
      <div class="col-md-12">
        <h4 class="header-underline"
          style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 27px;margin-top: 35px;">WHAT MAKES
          SHIPPN SPECIAL?</h4>
      </div>
    </div>
    <div style="margin-top: 35px;" class="row">
      <div style="text-align: center;" class="col-sm-12 col-md-12 col-lg-4">
        <div class="shippn-homepage-what-makes-shippn-special">
          <img fetchpriority="low" style="width: 40px;margin-bottom: 15px;" loading="lazy" decoding="auto"
            src="../assets/img/homeicon.webp" alt="Home icon, half world and home.">
          <h4 style="text-align: center;font-size: 16px;font-weight: bold;margin-bottom: 12px;">Make The World Your Home
          </h4>
          <p style="font-size: 13px;line-height: 27px;">Want to buy a product from abroad, but the seller doesn't ship
            to your country? <strong>No worries, </strong> you can use our hosts' addresses to shop from any merchant in
            the world.
          </p>
        </div>
      </div>
      <div style="text-align: center;" class="col-sm-12 col-md-12 col-lg-4">
        <div class="shippn-homepage-what-makes-shippn-special">
          <img fetchpriority="low" style="width: 40px;margin-bottom: 15px;" loading="lazy" decoding="auto"
            src="../assets/img/worldicon.webp" alt="Rocket take off form earth icon">
          <h4 style="text-align: center;font-size: 16px;font-weight: bold;margin-bottom: 12px;">World-Class Handling
          </h4>
          <p style="font-size: 13px;line-height: 27px;">Let the world's best carriers handle your packages. Our
            logistics partners, <strong>DHL, TNT, UPS, </strong> and <strong>FedEx</strong> will deliver your packages
            within <br> <strong>1-5
              business days!</strong></p>
        </div>
      </div>
      <div style="text-align: center;" class="col-sm-12 col-md-12 col-lg-4">
        <div class="shippn-homepage-what-makes-shippn-special">
          <img fetchpriority="low" style="width: 40px;margin-bottom: 15px;" loading="lazy" decoding="auto"
            src="../assets/img/taxicon.webp" alt="Shipping Rates icon">
          <h4 style="text-align: center;font-size: 16px;font-weight: bold;margin-bottom: 12px;">Great Shipping Rates
          </h4>
          <p style="font-size: 13px;line-height: 27px;">Get the best service at an affordable price. We always get the
            best
            shipping rates from our logistics partners thanks to our rapidly growing volume.</p>
        </div>
      </div>
    </div>
  </div>
  <div style="background: black;margin-top: 80px;">
    <div style="padding-top:50px;padding-bottom: 50px;" class="shippn-homepage-container container">
      <div class="row">
        <div class="col-md-3 shippn-4-infos">
          <div>
            <img fetchpriority="low" loading="lazy" decoding="auto" src="../assets/img/team-host.webp"
              alt="hosts icon, three people icon" width="30px" height="30px">
            <div>
              <h4>Hosts</h4>
              <p style="font-size: 12px;;margin-bottom: 0;color: white;line-height: 19px;">Our hosts are ready to help
                you with shopping from more than {{hostCountriesCount}} countries.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 shippn-4-infos">
          <div>
            <img fetchpriority="low" loading="lazy" decoding="auto" width="30px" height="30px"
              src="../assets/img/male-telemarketer.webp" alt="customer services icon, male telemarketer.">
            <div>
              <h4>Customer Service</h4>
              <p style="font-size: 12px;;margin-bottom: 0;color: white;line-height: 19px;">Our team works to give you
                the highest quality service based on your needs</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 shippn-4-infos">
          <div>
            <img fetchpriority="low" loading="lazy" decoding="auto" width="30px" height="30px"
              src="../assets/img/low-costs.webp" alt="low costs icon, dollar sign on hand icon.">
            <div>
              <h4>Low Costs</h4>
              <p style="font-size: 12px;;margin-bottom: 0;color: white;line-height: 19px;">We are working hard to offer
                you the best prices for the best service.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 shippn-4-infos">
          <div>
            <img fetchpriority="low" loading="lazy" decoding="auto" width="30px" height="30px"
              src="../assets/img/fast-reliable.webp" alt="fast reliable icon, hand shake icon. ">
            <div>
              <h4>Fast & Reliable Delivery</h4>
              <p style="font-size: 12px;;margin-bottom: 0;color: white;line-height: 19px;">We work with world-renowned
                couriers to ship your products</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="background: black;">
    <div class="shippn-homepage-container container">
      <div class="row">
        <div style="margin-top: 50px;margin-bottom: 35px;" class="col-md-12">
          <div style="float: left;display: flex;align-items: center;">
            <i style="color: white;font-size: 24px;margin-right: 10px;" class="fab fa-instagram"></i>
            <span style="color: white;">/ shippncom</span>
          </div>
          <div style="float: right;">
            <a target="_blank" href="https://www.instagram.com/shippncom/">
              <h4 style="color: #ff7700;margin-top: 0;margin-bottom:0;font-size: 15px;text-decoration: underline;">
                Follow us</h4>
            </a>
          </div>
        </div>
      </div>
    </div>
    <h4
      style="font-size: 26px;color: white;margin-top: 40px;padding-bottom: 30px;text-align: center;font-weight: bold;margin-bottom: 0;">
      OUR PARTNERS</h4>
  </div>
</div>
<!-- Edit Modal -->
<div class="modal fade" id="hostCountryRequestModal" tabindex="-1" aria-labelledby="Host Country Request Modal"
  aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background: #222222;" class="modal-header">
        <h5 style="color: white;padding-left: 15px;" class="modal-title" id="countryRequestModalTitle">Country Request
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span style="color: white;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <form ngNativeValidate [formGroup]="form">
        <div style="padding-left: 50px;padding-right: 50px;" class="modal-body">
          <div class="row">
            <div style="text-align: center;" class="col-md-12">
              <p style="color: black;text-align: center;font-size: 16px;font-weight: normal;margin-bottom: 5px;">
                Currently, we can only ship to the countries on the list, but Shippn is a growing community with the
                power of its hosts. If you can choose the country you want to shop from, you can be sure that we will do
                our best to give you the best service.</p>
            </div>
            <div style="margin-top: 20px;" class="col-12 col-lg-6">
              <label for="requestSelect"
                style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 5px;">
                Please select a country</label>
              <select formControlName="country"
                style="margin-bottom: 0px; width: 100%; border-radius: 5px;padding: 11px 14px;background-color: transparent;font-size: 14px;height: 42px; z-index: 2;cursor: pointer;position: relative;"
                name="requestSelect" id="requestSelect">
                <option *ngFor="let countryData of requestNonHostList;trackBy:trackByIndex"
                  value="{{countryData.code}}">
                  {{countryData.name}}</option>
              </select>
            </div>
            <div style="margin-top: 20px;" class="col-12 col-lg-6">
              <p style="color: black;text-align: left;font-size: 16px;font-weight: bold;margin-bottom: 5px;">
                Your email address</p>
              <input type="email" [attr.disabled]="token" formControlName="email"
                [ngClass]="{'shippn-border-red':form.get('email').touched && form.get('email').invalid}"
                placeholder="Email Address" class="form-control form-control-sm shippn-input">
            </div>
          </div>
          <div class="row">
            <div style="margin-top: 10px;" class="col-md-12">
              <button (click)="saveHostRequest()" style="width: 100px;font-size: 16px;font-weight: normal;height: 38px;"
                class="btn shippn-from-to-area-go-btn"
                aria-labelledby="Submit Host Country Request Form">Submit</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="influencerVideoModal1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Influencer Video</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <iframe width="560" height="315" [src]="influencerVideos[0].video_url | safeUrl " title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>
<h1 style="position: absolute; top: -100vh; left: -100vw; z-index: -1; user-select: none;">
  International Shipping Service: Global Shop Options
</h1>